const Base62 = {
  encode(b64: string) {
    let out = '';
    for (const ch of b64) {
      if (ch === '+') out += 'zA';
      else if (ch === '/') out += 'zB';
      else if (ch === 'z') out += 'zz';
      else out += ch;
    }
    return out;
  },

  decode(s: string) {
    let b64 = '';
    for (let i = 0; i < s.length; i++) {
      const ch = s[i];
      if (ch === 'z') {
        if (i + 1 >= s.length) {
          throw new Error("Invalid Base62: trailing 'z' with no escape char");
        }
        const nxt = s[++i];
        if (nxt === 'A') b64 += '+';
        else if (nxt === 'B') b64 += '/';
        else if (nxt === 'z') b64 += 'z';
        else throw new Error(`Invalid escape after z: ${nxt}`);
      } else {
        b64 += ch;
      }
    }
    return b64;
  },
};

function encodeUTF8ToBase64(str: string) {
  const bytes = new TextEncoder().encode(str);
  let binary = '';
  // @ts-ignore
  for (const b of bytes) binary += String.fromCharCode(b);
  return btoa(binary);
}

function decodeBase64ToUTF8(b64: string) {
  const mod = b64.length % 4;
  if (mod) b64 += '='.repeat(4 - mod);

  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new TextDecoder().decode(bytes);
}

export function smartDecode(input: string) {
  const hasZ = input.includes('z');

  try {
    const b64 = hasZ ? Base62.decode(input) : input;
    return decodeBase64ToUTF8(b64);
  } catch (error) {
    console.error(error);
    return '/';
  }
}

export function encodeToBase62(str: string) {
  const b64 = encodeUTF8ToBase64(str);
  return Base62.encode(b64);
}
